<template>
    <div class="dust-animation-container">
        <div
            v-for="(dust, index) in dustParticles"
            :key="`dust-${index}`"
            class="dust-particle"
            :style="{
                left: dust.left + '%',
                top: dust.top + '%',
                animationDelay: dust.delay + 's',
                animationDuration: dust.duration + 's',
                width: dust.size + 'px',
                height: dust.size + 'px',
            }"
        ></div>
    </div>
</template>

<script>
export default {
    name: "DustAnimation",
    data() {
        return {
            dustParticles: [],
        };
    },
    mounted() {
        this.generateDustParticles();
    },
    methods: {
        generateDustParticles() {
            this.dustParticles = [];
            for (let i = 0; i < 12; i++) {
                this.dustParticles.push({
                    left: Math.random() * 100,
                    top: Math.random() * 100,
                    delay: Math.random() * 3,
                    duration: 3 + Math.random() * 2,
                    size: 2 + Math.random() * 3, // 2px ~ 5px
                });
            }
        },
    },
};
</script>

<style scoped>
.dust-animation-container {
    position: absolute;
    top: 0;
    left: 0%;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
}

.dust-particle {
    position: absolute;
    background: linear-gradient(45deg, #a5d6a7, #c8e6c9);
    border-radius: 50%;
    opacity: 0.6;
    animation: dustFloat linear infinite;
}

@keyframes dustFloat {
    0% {
        transform: translate(0, 0) rotate(0deg);
        opacity: 0;
    }
    10% {
        opacity: 0.6;
    }
    25% {
        transform: translate(20px, -15px) rotate(90deg);
    }
    50% {
        transform: translate(-10px, 10px) rotate(180deg);
    }
    75% {
        transform: translate(15px, -5px) rotate(270deg);
    }
    90% {
        opacity: 0.6;
    }
    100% {
        transform: translate(0, 0) rotate(360deg);
        opacity: 0;
    }
}
</style>
